module.exports = __webpack_public_path__ + "static/media/javascript.e797a8c5.png";